import { entity } from "simpler-state";

export const screen = entity("Home");

export const setScreen = (newScreen: string) => {
  screen.set(newScreen);
};
